import { IconType } from '@/ui-kit/components/icon/enums';

export const FACEBOOK_BASE_SHARE_URL = 'http://www.facebook.com/sharer.php?u=';
export const TWITTER_BASE_SHARE_URL = 'http://www.twitter.com/share?url=';

export const SOCIAL_BUTTONS_CONFIG = [
  {
    name: 'Facebook',
    shareBaseUrl: FACEBOOK_BASE_SHARE_URL,
    icon: IconType.FacebookCircle,
  },
  {
    name: 'Twitter',
    shareBaseUrl: TWITTER_BASE_SHARE_URL,
    icon: IconType.TwitterCircle,
  },
];

export const MODAL_COPY = {
  title: 'Share this search',
  socialShare: 'Or share this search via',
};
